var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"powered_by_container"},[_c('div',[_c('div',{staticClass:"powered_by_label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('a',{attrs:{"href":"https://kasisto.com","target":"_blank","tabindex":!_vm.isLiveChatStarted? '0': '-1'}},[_c('img',{staticClass:"powered_by_logo",attrs:{"src":_vm.logoUrl}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }